<template>
  <div class="echarts">
    <IEcharts :option="bar" :loading="loading" />
  </div>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
export default {
  name: "TransactionChart",
  components: {
    IEcharts
  },
  props: {
    DetailParams: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    loading: true,
    bar: {
      title: {
        text: "Gráfico Detalle de Transacciones de Navition"
      },
      tooltip: {},
      xAxis: {
        data: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31"
        ]
      },
      yAxis: {},
      series: [
        {
          name: "Dia : Cantidad de Transacciones",
          type: "line",
          data: []
        }
      ]
    }
  }),
  methods: {
    async getChartData() {
      const that = this;
      await this.$http
        .get("/api/accountsReceivable/NavitionTransactionChartData", {
          params: {
            Year: this.DetailParams.Year,
            Month: this.DetailParams.Month,
            CompanyId: this.DetailParams.CompanyId,
            UserName: this.DetailParams.UserName,
            DocumentType: this.DetailParams.DocumentType
          }
        })
        .then((resp) => {
          that.bar.series[0].data = Object.values(resp.data[0]);
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 93%;
  height: 400px;
  background-color: #f3f7fa;
  border-radius: 30px;
  margin: 30px;
  padding: 10px;
}
</style>
